import { FlexContainer, H1Text, Hr, Input, LabelText, SelectBox, SubmitButton, Text } from "../../design";
import { Col, Container, Row } from "react-awesome-styled-grid";
import Customer from "../customer";
import MetaData from "../metaData";
import PaymentError from "../paymenterror";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js"
import currencyFormatter from "../../utils/currencyformatter";
import { COUNTRY_PHONE_CODE, ACCOUNT_MDR } from "../../appconstants";
import { format } from "../../utils/timer";
import { AmountDivideByHundred } from "../../helper";
import { ErrorMessage } from "@hookform/error-message";
import { Select, notification } from "antd";
import { getCheckoutChallanCharges } from "../../api";


const { Option } = Select;


type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  showAddress: boolean,
  submit: Function,
  cancel: Function,
  showCancelBtn: boolean,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  preFillWCCustomer: Object,
  paymentPagePay: boolean,
  headerText: string,
  buttonText: string,
  disableButtonText: string,
  customerValidation: boolean,
  requiredPhone: boolean,
  alpha2: string,
  wcalpha2: String,
  prefix: string,
  billAmount: string,
  planStartDate: Object,
  currentDateObject: Object,
  hideCustomer: boolean,
  showBillDetails: Boolean,
  cancelButtonText: string,
  expireyText: String,
  count: Number,
  charges: boolean,
  getPaymentCharges: Function,
  gst: Number,
  convenience: Number,
  totalAmount: Number,
  userType: String,
  payments: Object,
  upiError: String,
  isZipCodeRequired: Boolean,
  isBillingAdressRequired: Boolean,
  showWhatsAppNotify: Boolean,
  showPromoter: Boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  serviceFee: Number,
  serviceFeeRate: Number,
  tip: Number,
  discount: Number,
  serviceFeeRateVal: Number,
  serviceFeeVal: Number,
  isInvoice: Boolean,
  tax: Number,
  totalPayable: Number,
  subTotal: Number,
  tabName: String,
  validateAmount: Number,
  validateInvoice: Boolean,
  payment: Object,
  chargeByApplePay: funcctiin,
  ApplePayment: Boolean,
  accountId: String,
  showMeta: Boolean,
  metaInfo: Object,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
}

const ChallanPayment = (props: Props) => {



  const { submit, preFillCustomer, expireyText, tabName, validateInvoice,  count,  payments, upiError,
    headerText, errorHeader, errorMsg,
    customerReadOnly, customerValidation, preFillWCCustomer, wcalpha2, alpha2,  requiredPhone, disableButtonText, planStartDate, userType, paymentPagePay, customerFields, serviceFee, serviceFeeRate, tip, discount,
    billAmount, prefix, currentDateObject, hideCustomer, showCancelBtn, cancel, showBillDetails,
    amount, serviceFeeVal, tax, totalPayable, subTotal, showMeta, metaInfo, netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled,   checkoutPageId, convenience , gst, totalAmount, getPaymentCharges} = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [customerReadOnlyList, setCustomerReadOnlyList] = useState([]);
  const [defaultCountry, setDefaultCountry] = useState(null);
  const [pinCode, setPinCode] = useState(null);
  const [countryCode, setCountryCode] = useState("+91");

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
    register
  } = useForm();

  const [isApplePay, setIsApplePay] = useState(false);

  useState(() => {
    if (window.ApplePaySession) {
      setIsApplePay(true);
    }
  }, []);


  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  
  useEffect(() => {
    getPaymentCharges(null, payments)
  },[]);




  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      if (defaultCountry) {
        reset({
          cname: preFillCustomer && preFillCustomer.name || "",
          email: preFillCustomer && preFillCustomer.email || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          country: defaultCountry || "",
          zipCode: pinCode || "",
        })
      } else {
        reset({
          cname: preFillCustomer && preFillCustomer.name || "",
          email: preFillCustomer && preFillCustomer.email || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        })
      }
    }
  }, [reset, preFillCustomer, tabName]);

  useEffect(() => {
    if (preFillWCCustomer) {
      let phone;
      let countryCallingCode;
      if (preFillWCCustomer && preFillWCCustomer.wcBillingAddress) {
        if (preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone.includes('+')) {
          phone = preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone && AsYouType(preFillWCCustomer.wcBillingAddress.phone);
          countryCallingCode = phone && `+${phone.countryCallingCode}` || wcalpha2 && `+${getCountryCallingCode(wcalpha2)}`;
        } else {
          phone = preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.phone;
          countryCallingCode = wcalpha2 && `+${getCountryCallingCode(wcalpha2)}`;
        }
        reset({
          cname: (preFillWCCustomer && preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.firstName) || "",
          email: (preFillWCCustomer && preFillWCCustomer.wcBillingAddress && preFillWCCustomer.wcBillingAddress.email) || "",
          phone: (phone && phone.nationalNumber) ? phone && phone.nationalNumber : phone ? phone : "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        })
      }
    }
  }, [reset, preFillWCCustomer]);

  useEffect(() => {
    if (paymentPagePay) {
      const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      if (defaultCountry) {
        reset({
          cname: customerFields && customerFields.name || "",
          email: customerFields && customerFields.contactUsEmail || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
          country: defaultCountry || "",
          zipCode: pinCode || "",
        })
      } else {
        reset({
          cname: customerFields && customerFields.name || "",
          email: customerFields && customerFields.contactUsEmail || "",
          phone: phone && phone.nationalNumber || "",
          countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        })
      }
    }
  }, [reset, customerFields, tabName])

  useEffect(() => {
    reset({
      country: defaultCountry || "",
      zipCode: pinCode || "",
    })
  }, [defaultCountry, pinCode]);

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  useEffect(() => {
    setCustomerReadOnlyList([]);
    if (validateInvoice === true) {
      if (customerReadOnly) {
        setCustomerReadOnlyList(['name', 'email']);
      }
    } else {
      if (customerReadOnly) {
        setCustomerReadOnlyList(['name', 'email', 'phone']);
      }
    }
  }, [props.customerReadOnly]);

  const backToUrl = () => {
    const slug = localStorage.getItem('slugName');
    const tableGid = localStorage.getItem('shopTable');
    let redirect = 'https://staging-order.swirepay.com';
    if (process.env.REACT_APP_ENV === "Production") {
      redirect = 'https://order.swirepay.com';
    }
    localStorage.removeItem('shopTable');
    localStorage.removeItem('slugName');
    const url = `${redirect}/${slug}?tableGid=${tableGid}`;
    window.location = url;
  };



  const onSubmit = data => {
    const { name, phoneNumber, email } = data;
    if(countryCode === ""){
      notification.error({
        description:    <div style={{ color: 'red' , fontWeight:600 }}>
          Country code required
        </div>,
      });
    }
    else{

      const phoneNumberWithCountrycode = `${countryCode}${phoneNumber}`;


      // Construct the customer object
      const customer = {
        email: email,
        name: name,
        phoneNumber: phoneNumberWithCountrycode
      };

      // Construct the finalData object
      const finalData = {
        customer: customer,
        paymentMethod: {
          type: "CHALLAN"
        }
      };
      submit(finalData)
    }
  };


  const onCancel = () => { showCancelButton && cancel && cancel(); };

  const onCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };



  return (
    <>
      {expireyText && (
        <p className="px-1 px-md-4 mb-4">
          {expireyText}{" "}
          <span style={{ fontWeight: "600" }}>{format(count)}</span>
        </p>
      )}
      <H1Text className="px-1 px-md-4 mb-0">
        {headerText || "Pay With Challan"}
      </H1Text>

      <form

        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit(onSubmit)(e);
        }}
        //onSubmit={handleSubmit(onSubmit)}

        onChange={() => setShowErrorMessage(false)}
        style={{
          width: "100%",
        }}
      >
        <LabelText>Name</LabelText>
        <Controller
          defaultValue={""}
          marginBottom="0px"
          control={control}
          name="name"
          placeholder="Name"
          color={errors.name ? "red" : "inherit"}
          rules={{
            required: "Name is Required",
            pattern: {
              value: /^[a-zA-Z ]*$/,
              message: "Name can only contain alpha characters and spaces.",
            },
          }}
          as={Input}
        />
        <ErrorMessage
          errors={errors}
          name="name"
          render={({ message }) => (
            <Text
              fontSize="12px"
              marginTop="4px"
              marginBottom="0px"
              color="#ff1e1e"
            >
              {message}
            </Text>
          )}
        />
        <LabelText>E-Mail</LabelText>
        <Controller
          defaultValue={""}
          marginBottom="0px"
          control={control}
          name="email"
          placeholder="E-mail"
          color={errors.name ? "red" : "inherit"}
          rules={{
            required: "E-mail is Required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          }}
          as={Input}
        />
        <ErrorMessage
          errors={errors}
          name="email"
          render={({ message }) => (
            <Text
              fontSize="12px"
              marginTop="4px"
              marginBottom="0px"
              color="#ff1e1e"
            >
              {message}
            </Text>
          )}
        />

        <div className="mb-3">
          <LabelText>Phone Number</LabelText>{" "}
          <div className="d-flex" verticalAlign="middle">
            <SelectBox
              className="col-1 "
              value={countryCode}
              style={{ color: '#6A6A6A' }}
              onChange={onCountryCodeChange}
              showSearch
            >
              {
                COUNTRY_PHONE_CODE
                  .map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))
              }
            </SelectBox>
            <Controller
              defaultValue={""}
              control={control}
              style={{ width: "27%" }}
              name="phoneNumber"
              placeholder="Phone Number"
              color={errors.phoneNumber ? "red" : "inherit"}
              rules={{
                required: "Phone Number is Required",
                pattern: {
                  value: /^\d{10}$/,
                  message: "Please enter a valid 10-digit phone number.",
                },
              }}
              as={Input}
            />
          </div>
          <ErrorMessage
            errors={errors}
            name="phoneNumber"
            render={({ message }) => (
              <Text fontSize="12px" marginTop="10px" marginBottom="0px" color="#ff1e1e">
                {message}
              </Text>
            )}
          />
        </div>

        <FlexContainer flexDirection="column">
          {!hideCustomer ? (
            <>
              <div className="px-1 px-md-4 mt-2">
                <Customer
                  control={control}
                  errors={errors}
                  readOnly={customerReadOnlyList}
                  validateInvoice={validateInvoice}
                  requiredPhone={requiredPhone}
                  validation={customerValidation}
                />
              </div>
              <Hr />
            </>
          ) : (
            <></>
          )}

          <div className="px-1 px-md-4">
            {showMeta && (
              <MetaData
                control={control}
                errors={errors}
                alpha2={alpha2}
                metaInfo={metaInfo}
              />
            )}
          </div>

          {serviceFeeEnabled === true && (
            <>
              <Hr />
              <div className="">
                <div class="mt-4">
                  <table class="table table-bordered mt-4">
                    <tbody>
                      <tr style={{ borderBottom: "hidden" }}>
                        <th scope="row">Amount:</th>
                        <td>
                          {prefix} {AmountDivideByHundred(netAmount)}
                        </td>
                      </tr>
                      <tr style={{ borderBottom: "hidden" }}>
                        <th scope="row">Service Fee:</th>
                        <td>
                          {prefix} {AmountDivideByHundred(serviceFeeAmount)}
                        </td>
                      </tr>
                      <tr style={{ background: "#F7F7F7" }}>
                        <th scope="row">Total Payable:</th>
                        <td class="font-weight-bold">
                          {prefix} {AmountDivideByHundred(totalPayableAmount)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
          <div className="px-1">
            {showBillDetails && userType !== ACCOUNT_MDR.MERCHANT && (
              <div class="mt-4">
                <table class="table table-bordered mt-4">
                  <tbody>
                    <tr style={{ borderBottom: "hidden" }}>
                      <th scope="row">Bill Amount:</th>
                      <td>{billAmount}</td>
                    </tr>
                    <tr style={{ borderBottom: "hidden" }}>
                      <th scope="row">Convenience Fee:</th>
                      <td>
                        {prefix} {convenience}
                      </td>
                    </tr>
                    <tr style={{ borderBottom: "hidden" }}>
                      <th scope="row">GST:</th>
                      <td>
                        {prefix} {gst}
                      </td>
                    </tr>
                    <tr style={{ background: "#F7F7F7" }}>
                      <th scope="row">Total Payable:</th>
                      <td class="font-weight-bold">{totalAmount}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {subTotal !== totalPayable ? (
              <>
                {(serviceFee || serviceFeeRate || discount || subTotal) && (
                  <div class="mt-4">
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: "hidden" }}>
                          <th scope="row">Amount:</th>
                          <td>
                            {prefix} {AmountDivideByHundred(amount)}
                          </td>
                        </tr>
                        {discount && discount !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Discount:</th>
                            <td>
                              {prefix} ({AmountDivideByHundred(discount)})
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {subTotal && subTotal !== 0 ? (
                          <tr>
                            <th scope="row">Sub Total:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(subTotal)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {tax && tax !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Tax:</th>
                            <td>
                              {prefix} {tax ? AmountDivideByHundred(tax) : 0.0}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {serviceFeeVal && serviceFeeVal !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Service Fee:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(serviceFeeVal)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {tip && tip !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Tip:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(tip)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        <tr style={{ background: "#F7F7F7" }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">
                            {prefix} {AmountDivideByHundred(totalPayable)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            ) : subTotal === totalPayable ? (
              <>
                {(serviceFee || serviceFeeRate || discount || subTotal) && (
                  <div class="mt-4">
                    <table class="table table-bordered mt-4">
                      <tbody>
                        <tr style={{ borderBottom: "hidden" }}>
                          <th scope="row">Amount:</th>
                          <td>
                            {prefix} {AmountDivideByHundred(amount)}
                          </td>
                        </tr>
                        {discount && discount !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Discount:</th>
                            <td>
                              {prefix} ({AmountDivideByHundred(discount)})
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {subTotal && subTotal !== 0 ? (
                          <tr>
                            <th scope="row">Sub Total:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(subTotal)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {tax && tax !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Tax:</th>
                            <td>
                              {prefix} {tax ? AmountDivideByHundred(tax) : 0.0}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {serviceFeeVal && serviceFeeVal !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Service Fee:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(serviceFeeVal)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        {tip && tip !== 0 ? (
                          <tr style={{ borderBottom: "hidden" }}>
                            <th scope="row">Tip:</th>
                            <td>
                              {prefix} {AmountDivideByHundred(tip)}
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                        <tr style={{ background: "#F7F7F7" }}>
                          <th scope="row">Total Payable:</th>
                          <td class="font-weight-bold">
                            {prefix} {AmountDivideByHundred(totalPayable)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            ) : (
              <></>
            )}



            <FlexContainer
              width="100%"

            >
              <SubmitButton type="submit" >
                {"Generate Challan"}
              </SubmitButton>

            </FlexContainer>
            <Text >
              A Challan for your payment is available for download. Please <br></br>make the payment before the Challan expiration date.</Text>




            {localStorage.getItem("slugName") &&
              localStorage.getItem("shopTable") && (
                <FlexContainer
                  width="100%"
                  alignItems="center"
                  className="justify-content-md-between justify-content-around"
                >
                  <span
                    style={{
                      marginTop: "10px",
                      marginBottom: "15px",
                      paddingLeft: "10px",
                      color: "#30A0FF",
                      fontSize: "18px",
                      fontWeight: "500",
                      cursor: "pointer",
                    }}
                    onClick={() => backToUrl()}
                  >
                    Back
                  </span>
                </FlexContainer>
              )}
          </div>
        </FlexContainer>
      </form>
      {isShowErrorMessage && (
        <PaymentError header={errorHeader} message={errorMsg} />
      )}
      {upiError && (
        <Container className="w-100 p-0 text-break">
          <Row id="error" className="ml-4">
            <Col md={7} noGutter className="px-2">
              <Text color="#ff1e1e">{upiError}</Text>
            </Col>
          </Row>
        </Container>
      )}
      {disableButtonText && planStartDate < currentDateObject && (
        <PaymentError
          header={disableButtonText}
          message={"For more information, please contact support@swirepay.com"}
        />
      )}
    </>
  );
};

export default ChallanPayment
